<a class="avatar-container">
    <div [class]="clase">
      <img
        *ngIf="imagen && imagenEncontrada"
        [src]="imagen"
        alt="Avatar"
        class="avatar-image"
      >
      <div
        *ngIf="!imagen || !imagenEncontrada"
        class="avatar-iniciales"
      >
        {{ getInicialesNombre(nombre) }}
      </div>
    </div>
    <span *ngIf="nombre && tipo == 'completo'">{{ nombre }}</span>
  </a>